export default {
  itemVisible (state) {
    return state.itemModal
  },
  selectedItem (state) {
    return state.selectedItem
  },
  selectedItemPrice (state) {
    return state.selectedItem.price
  },
  selectedItemPriceTable (state) {
    return state.selectedItem.priceTable
  },
  selectedItemPriceVariations (state) {
    return state.selectedItem.priceVariations
  },
  registeredItems (state) {
    return state.registeredItems
  },
  registeredItemsActive (state) {
    return state.registeredItems.filter(elem => elem.active)
  },
  loadingItemAction (state) {
    return state.loadingItemAction
  },
  termsOfUseContent (state) {
    return state.selectedItem.termsOfUseContent
  },
  isImg (state) {
    return state.selectedItem.images !== null && state.selectedItem.images.length > 0
  },
  shelfedImage (state) {
    return state.imageNotSent
  },
  imgUploadVisible (state) {
    return state.imgUploadModal
  },
  imgUploadIndex (state) {
    return state.imgUploadIndex
  },
  cupoms (state) {
    return state.cupoms
  },
  selectedCupom (state) {
    return state.selectedCupom
  },
  cupomVisible (state) {
    return state.cupomModal
  },
  cupomCurrentPage (state) {
    return state.cupomCurrentPage
  },
  cupomTotalPages (state) {
    return state.cupomTotalPages
  },
  cupomTotalItems (state) {
    return state.cupomTotalItems
  },
  cupomItemsPerPage (state) {
    return state.cupomItemsPerPage
  },
  loadingCupomAction (state) {
    return state.loadingCupomAction
  },
  listItens (state) {
    return state.listItens
  }
}



// WEBPACK FOOTER //
// ./src/store/item/getters.js